import angular from 'angular';
import eventDetailComponent from './event-detail.component';
import EventDetailService from './event-detail.service';
import eventDetailConfig from './event-detail.config';


let eventDetailModule = angular.module('eventDetail',[])
  .component('eventDetail', eventDetailComponent)
  .service('eventDetailService', EventDetailService)
  .config(eventDetailConfig);

export default eventDetailModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/events/event-detail/event-detail.js
 **/